import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";

import { SearchService } from "services";
import { ISearchResults } from "types";

import { SearchInput } from "./components/SearchInput";
import { SearchResults } from "./components/SearchResults";
import { SearchPager } from "./components/SearchPager";
import { SearchLoader } from "./components/SearchLoader";
import { getTranslations } from "./utils";
import { SearchFilters } from "./components/SearchFilters";

export type SearchFiltersOption = {
  key: string;
  id: string;
  title: string;
  slug: string;
};

export type SearchFiltersData = {
  key: string;
  slug: string;
  title: string;
  type: string;
  options: SearchFiltersOption[];
}[];

interface Props {
  searchFiltersData: SearchFiltersData;
}

const plus = (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    width="25"
    height="25"
    fill="none"
    viewBox="0 0 25 25"
  >
    <path
      fill="#EF4135"
      d="M5.956 11.101c-.014-.034-.035-.065-.04-.1-.008-.042.024-.071.065-.067.066.005.133.014.2.015.073.002.147-.003.221-.01.068-.006.074-.025.062-.104-.011-.07-.011-.142-.02-.212-.009-.066-.024-.132-.032-.198a.265.265 0 0 1 .013-.11.282.282 0 0 0 .007-.15c-.015-.086.034-.172.111-.195.07-.02.144-.025.216-.03.036-.003.073.01.11.013.176.01.349.01.527-.02.252-.043.51-.077.768-.052a.861.861 0 0 0 .411-.059c.102-.04.229-.081.338.01.081-.004.162-.004.242-.016.175-.024.35-.035.527-.04V9.77c-.011.057.018.09.07.08.063-.012.123-.046.192-.023 0 0 .013-.018.013-.029.001-.044.035-.048.061-.037.047.019.088.05.135.07.01.002.045-.02.044-.03-.003-.034-.018-.089.039-.054a.209.209 0 0 0 .163.032c.072-.016.144-.027.216-.037.072-.011.144-.022.216.008.031.013.052-.005.06-.041.014-.071.036-.141.05-.213.01-.045-.005-.117.018-.132.037-.021.097-.004.147-.002-.023.052-.047.104-.068.158-.01.025.016.06.046.054.017-.002.044-.017.047-.031.015-.064.02-.128-.03-.182.04-.041.013-.086.006-.129l-.001.008c.04-.07.06-.143.031-.222v-.012l.007.012c-.036-.003-.087-.004-.084-.047.01-.212-.056-.434.064-.635.004-.006.01-.01.016-.015h-.005l.013.19c.004.045.026.073.043.053.014-.014.03-.035.03-.052.005-.12.022-.245-.053-.353v.009c.05-.042.061-.097.068-.158a.282.282 0 0 1 .046-.144c.172-.217.136-.458.079-.695-.016-.064-.045-.126-.034-.192.03-.172.02-.353.086-.517.024-.059.014-.112.009-.172-.028-.273-.032-.546-.08-.815a.61.61 0 0 1 0-.199c.02-.13.046-.262.075-.392.006-.02.048-.052.06-.048.054.026.095.017.138-.023.013-.013.046-.022.061-.013.076.036.126.003.175-.048a.133.133 0 0 1 .056-.036.085.085 0 0 1 .058.012c.066.037.07.04.076-.029.012-.106.081-.168.162-.218.019-.012.075-.007.082.007.043.08.085.086.152.025.03-.028.083-.03.122-.05.037-.02.078-.042.106-.074.033-.038.065-.053.114-.045.06.009.118.015.177.015.036.001.082 0 .106-.02a.25.25 0 0 1 .162-.055c.04-.002.077-.037.115-.06.07-.042.07-.042.134.045.034.044.046.046.07-.008.017-.042.03-.067.076-.035.005.005.012.01.015.015.044.064.149.027.18.11.034.09.074.177.105.267.014.045.022.086.081.086.063-.001.09.039.108.093.031.09.045.182.094.268.031.053.029.132.019.196-.04.279-.037.562-.054.843-.016.296-.028.592-.042.889-.003.066-.008.134-.007.2.003.297-.018.592-.03.888-.007.177.012.355-.025.53-.04.182-.011.37-.044.551-.004.021-.013.05-.004.065.068.096.034.198.029.301-.003.078.027.159.051.238.007.021.043.042.067.049.137.027.273.061.417.046.125-.013.252 0 .378 0 .021 0 .046-.001.066.002.087.016.173.044.26.048.088.004.174-.019.263-.02.08 0 .163-.023.236.037.014.013.043.012.064.012.244-.005.483.086.73.022.044-.01.102.034.116.086.015.051-.027.08-.06.107h-.012l.011-.007c.044.005.087.012.13.01.018 0 .05-.018.05-.03.002-.059.031-.073.084-.077.108-.008.216-.024.325-.03.023-.002.049.03.073.043.042.023.082.03.109-.024.028-.055.072-.033.111-.015l-.002.01-.004-.01c.108-.089.23-.055.337-.014.062.021.11.022.168.014.168-.027.335-.04.508-.019a.68.68 0 0 0 .304-.046.914.914 0 0 1 .35-.046c.113.005.22-.018.328-.048.128-.036.26-.059.392-.075.1-.013.181.02.248.11.131.177.11.103.092.326a.473.473 0 0 0 .026.194c.036.102.051.198-.014.295-.026.037-.015.07.025.09.034.017.013.035.007.053-.018.056-.037.111-.053.168-.009.035.014.05.046.063.097.043.096.044.089.14-.007.085-.018.163.02.254.034.08.015.187-.036.274-.043.079-.047.157.033.219.034.027.036.058.03.098-.011.109-.062.216-.017.326-.027.082-.05.164-.084.244-.009.022-.048.035-.075.042-.035.011-.073.014-.11.016-.118.006-.197.047-.2.182 0 .033-.035.066-.043.1-.007.027-.011.07.003.083.123.101.088.217.04.339a.976.976 0 0 0-.074.23c-.01.075-.04.126-.1.162-.05.03-.101.07-.157.084-.28.071-.563.13-.851.157-.056.005-.058-.03-.062-.068.014.013.029.033.031-.007l-.03.011c-.01-.01-.022-.026-.033-.026-.244.008-.487.01-.73-.014-.065-.007-.132.007-.198.008-.028.001-.065.01-.068-.032 0-.014.034-.026.043-.043.006-.015.004-.044-.006-.054-.047-.047-.111-.052-.167-.038-.126.03-.25.01-.376.016-.104.005-.207.003-.303.055-.037.02-.086.023-.13.028-.11.01-.22.014-.322.07a.223.223 0 0 1-.195.003c-.043-.019-.078-.017-.124-.014-.108.003-.21.027-.315.05-.291.07-.589.064-.885.07a.23.23 0 0 1-.086-.012.342.342 0 0 0-.295.01c-.076.035-.18.008-.271.003-.035-.002-.07-.023-.106-.03-.054-.01-.091.026-.08.075.01.035.025.07.033.106.02.101.035.2.008.308a.718.718 0 0 0 .011.308c.038.196.044.396.033.597-.001.03-.01.06-.004.088.07.35.054.708.1 1.06.045.362.082.722.12 1.084.01.089.005.18.016.267.023.198-.079.31-.258.352a.698.698 0 0 0-.238.109c-.019.012-.033.03-.053.042-.032.018-.066.046-.098.046-.118.002-.149.08-.168.173-.004.022-.017.044-.016.065.01.147-.1.22-.189.307-.014.014-.044.03-.057.024-.079-.037-.122.028-.181.052-.08.034-.151.099-.248.082-.019-.003-.042.011-.063.021a.434.434 0 0 1-.276.036c-.055-.009-.11-.003-.132.055-.03.08-.092.095-.161.076-.064-.017-.107-.013-.162.029-.036.027-.095.027-.145.036-.037.005-.088-.009-.106.012-.083.087-.185.069-.288.073a.648.648 0 0 0-.236.055c-.079.035-.159.034-.238.044-.028.003-.076-.008-.08-.023-.03-.091-.104-.074-.17-.088-.091-.018-.132-.092-.108-.181.006-.021.028-.043.024-.061-.034-.146.04-.255.114-.366.003-.003-.003-.014-.004-.021h.006c-.014 0-.034.007-.04 0-.014-.013-.03-.035-.03-.054-.006-.207-.056-.409-.036-.619.011-.107-.03-.22-.026-.328.002-.102.041-.203.044-.306.003-.101-.017-.206-.029-.308-.01-.08.001-.15.086-.186h-.007c.02 0 .044.003.061-.006.015-.009.023-.032.034-.05-.018-.006-.034-.014-.052-.015-.013-.002-.028.004-.042.007h.005c-.011-.018-.029-.035-.031-.055-.005-.035.013-.08-.001-.108-.08-.148-.044-.3-.03-.451.009-.103.022-.204-.004-.306a.355.355 0 0 1 0-.132c.002-.015.026-.03.045-.04.005-.003.023.012.033.02l.058.06c-.002-.008-.004.03-.006 0a.376.376 0 0 0 .044-.277c-.028-.115.02-.181.121-.226.019-.008.035-.035.051-.036.13-.008.127-.1.126-.191 0-.027-.014-.063-.035-.075-.017-.01-.051.003-.078.012-.063.02-.083.009-.08-.051l.008-.133v.005-.07l-.002.007s.013-.014.018-.014c.074.011.107-.006.105-.063a10.99 10.99 0 0 0-.019-.327c-.001-.01-.018-.017-.026-.026-.008.01-.019.018-.022.03-.005.014-.002.029-.006.043-.014.058-.014.058-.08.005v.004-.07.006c-.002-.064-.006-.127.02-.193.025-.065-.017-.048-.053-.03-.01.006-.035.003-.037-.004-.008-.02-.007-.044-.012-.064-.019-.087-.067-.14-.13-.11-.124.057-.25-.03-.369.024-.226-.036-.454.006-.68-.007-.013-.001-.025-.015-.037-.023.007-.011.015-.022.02-.035.002-.007-.004-.014-.005-.022-.004.004-.01.01-.01.016l.003.04c-.067.005-.134.017-.2.013-.088-.006-.174-.018-.236-.097-.026-.032-.07-.05-.105-.075.003-.003.003-.007.005-.012l-.003.012c-.069.01-.138.024-.207.03-.014 0-.031-.023-.048-.037v.006c.012-.03.053-.068-.016-.078-.028-.003-.076 0-.082.015-.033.067-.089.064-.15.069-.117.01-.232.013-.348.056-.077.03-.173.006-.263.004-.045-.001-.05-.05-.073-.073-.028-.028-.076-.045-.1-.015-.047.058-.09.045-.155.037-.125-.013-.25.002-.376.003-.045 0-.1-.003-.116-.049-.027-.082-.088-.092-.155-.094-.107-.002-.214-.032-.322.034-.05.03-.137.021-.195 0-.1-.036-.228.002-.298-.112-.004-.003-.014-.007-.018-.005-.066.035-.15.038-.186-.013-.069-.095-.182-.154-.225-.269a.26.26 0 0 1-.013-.104c.008-.074-.001-.161.037-.215.044-.063-.02-.106.005-.157.034-.072-.037-.086-.073-.112-.059-.039-.07-.087-.057-.153.022-.1.045-.202 0-.305-.01-.02.007-.053.011-.082.01-.058.04-.121.026-.171-.036-.122.008-.217.065-.313.032-.053.026-.1-.01-.142-.041-.045-.082-.085-.059-.154.024-.07.035-.14.115-.178.075-.036.072-.05.023-.115-.009-.011-.025-.019-.033-.03-.03-.044-.022-.077.024-.112.024-.018.048-.033.074-.05l.01.005-.01-.001.01.004Zm4.233 2.396.015.01-.015-.003-.063.001c-.005.001-.01.001-.014.003a.051.051 0 0 1 .014-.01c.021.023.043.026.063 0Zm.283-.532.069-.001c.013 0 .027.001.04-.001.003-.001.006-.01.008-.014l-.048.021c-.023.002-.046 0-.07.002l-.009-.004.01-.003Zm-.663.538.018-.002-.017.01-.063-.005c-.084.01-.167-.05-.251 0-.036-.01-.075-.013-.106-.03-.099-.048-.186-.021-.27.032l-.067.001a.843.843 0 0 0-.407-.037l-.064.001c-.004-.002-.01-.005-.017-.005-.002 0-.006.004-.008.006l.026-.006c.02.02.043.023.064-.001.085.106.22.02.317.08.016.01.06-.028.091-.044h.066c.02.041 0 .072-.03.098h-.015l.014-.006c.034.007.088.03.099.017.07-.083.168-.059.255-.079.02-.004.037-.021.055-.032.083.08.167.066.25-.001.021 0 .043.003.065.003h-.005Zm-1.484-.6h.013l-.013.003-.01-.001.01-.001Zm-.285-.035.012.003H8.03l.01-.004Zm2.401.63.066.003c.079.006.157.015.236.02.01 0 .023-.015.033-.023-.013-.01-.029-.032-.042-.032-.078.005-.162-.027-.228.04l-.067-.001c-.024-.015-.047-.034-.072-.046-.009-.004-.033.002-.037.011-.014.027.034.12.06.116.01-.001.022-.017.028-.027.01-.019.016-.04.023-.06Zm3.979-3.473.046.046c.006.006.022.004.034.005-.007-.01-.011-.028-.02-.033-.019-.007-.04-.007-.06-.012l-.086-.016c-.039-.008-.085-.01-.089.036-.002.026.034.062.06.082.02.016.056.02.084.02.015 0 .035-.026.038-.04.004-.03-.004-.059-.008-.087l.001-.001Zm-5.968 3.414c-.011-.006-.022-.02-.033-.02a.399.399 0 0 0-.086.017c-.01.003-.017.019-.025.03.012.005.024.015.037.015a.393.393 0 0 0 .087-.009c.009-.002.013-.022.019-.034v.001Zm8.385.222-.073.014c.004.014.007.03.016.039.026.026.059.024.068-.005.003-.01-.006-.025-.012-.049v.001Zm-9.112.24c.012-.005.034-.007.035-.014.002-.011-.008-.026-.013-.04-.011.005-.032.008-.033.013-.002.013.007.027.01.04l.001.002Zm2.17.166-.005-.018-.012.008.018.009h-.001Z"
    />
  </svg>
);

const min = (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    width="25"
    height="25"
    fill="none"
    viewBox="0 0 25 25"
  >
    <path
      fill="#EF4135"
      d="M15.883 14.066a4.72 4.72 0 0 0 1.803-.416 4.247 4.247 0 0 0 1.437-1.062c.198-.178.333-.41.39-.669a1.366 1.366 0 0 0-.064-.791c-.1-.258-.274-.49-.5-.668a1.673 1.673 0 0 0-.782-.338 14.869 14.869 0 0 0-3.542-.263c-2.223.077-4.425.274-6.635.488a7.034 7.034 0 0 0-1.908.51c-.36.15-.672.38-.908.675-.573.792-.23 1.521.768 1.74.75.13 1.506.212 2.26.246l6.513.428 1.168.12Z"
    />
  </svg>
);

export const SiteSearch: FC<Props> = ({ searchFiltersData }) => {
  const [results, setResults] = useState<ISearchResults>({
    results: [],
    total: 0,
  });
  const [loading, setLoading] = useState(false);

  const urlParams = new URLSearchParams(window.location.search);
  const urlTerm = urlParams.get("term");

  const [searchedTerm, setSearchedTerm] = useState<string>(urlTerm || "");
  const [currentPage, setCurrentPage] = useState<number>(1);

  const [facets, setFacets] = useState<string[]>([]);
  const [sorting, setSorting] = useState<string>("");

  const handleFacetChange = (value: string, checked: boolean) => {
    setFacets((prev) =>
      checked ? [...prev, value] : prev.filter((item) => item !== value)
    );
  };

  const amount = useMemo(() => 12, []);

  const searchWrapperRef = useRef<HTMLDivElement>(null);

  const updateUrlWithTerm = useCallback((term: string) => {
    const { location, history } = window;

    const url = new URL(location.href);
    url.searchParams.set("term", term);
    history.pushState({}, "", url);
  }, []);

  const search = useCallback(
    async (term: string, facets: string[], sortBy, page = 1) => {
      if (term) {
        setLoading(true);

        const searchResults = await SearchService.search({
          page,
          query: term,
          amount,
          facets,
          sortBy,
        });

        if (searchResults) {
          setResults(searchResults);
          searchWrapperRef?.current?.scrollIntoView({ behavior: "smooth" });
        }

        setLoading(false);
      } else {
        setResults({
          results: [],
          total: 0,
        });
      }

      updateUrlWithTerm(term);
    },
    [amount, updateUrlWithTerm]
  );

  useEffect(() => {
    search(searchedTerm, facets, sorting, currentPage);
  }, [searchedTerm, currentPage, search, facets, sorting]);

  const totalPerPage: number = useMemo(
    () => (results && results?.total / amount) || 1,
    [amount, results]
  );

  const resultLabel = useMemo(
    () => getTranslations("searchResult")?.toLowerCase(),
    []
  );
  const resultsLabel = useMemo(
    () => getTranslations("searchResults")?.toLowerCase(),
    []
  );

  const noResultsTxt = useMemo(() => getTranslations("searchNoResults"), []);

  return (
    <div ref={searchWrapperRef}>
      <SearchInput
        initialTerm={urlTerm}
        onInputChange={(term) => setSearchedTerm(term)}
      />
      {!!results?.total && (
        <>
          <div className="search-amount">
            {`${results.total} ${
              results.total > 1 ? resultsLabel : resultLabel
            }`}
          </div>
        </>
      )}
      <div className="search-container">
        <div className="faq__item filter--mobile">
          <button className="faq__title-wrapper">
            <span className="faq__title">Filters</span>
            <span className="faq__plus">{plus}</span>
            <span className="faq__min">{min}</span>
          </button>
          <div className="faq__content">
            <SearchFilters
              filters={searchFiltersData}
              facets={facets}
              handleFacetChange={handleFacetChange}
              handleSortChange={(value) => setSorting(value)}
            />
          </div>
        </div>
        <div className="filter--desktop">
          <SearchFilters
            filters={searchFiltersData}
            facets={facets}
            handleFacetChange={handleFacetChange}
            handleSortChange={(value) => setSorting(value)}
          />
        </div>
        {loading ? (
          <div className="search-loading">
            <SearchLoader />
          </div>
        ) : !!results?.results?.length ? (
          <SearchResults results={results.results} term={searchedTerm} />
        ) : (
          <p className="search-no-results">{noResultsTxt}</p>
        )}
      </div>
      {!!(results?.total > totalPerPage && results?.total > amount) &&
        !loading && (
          <SearchPager
            currentPage={currentPage - 1}
            totalPages={totalPerPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
        )}
    </div>
  );
};
